<template>
    <div class="col-xs-12">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h3 class="box-title">Extension</h3>
          <div class="box-tools pull-right">
            <button class="btn btn-info mr-5" :disabled="count >= 4" @click="create()"><i class="fa fa-plus mr-5"></i>New extension</button>
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
          </div>
        </div>
        <div class="box-body">
          <div class="row" v-if="$route.params.erp === 'etos'">
            <div class="col-xs-12">
              <div class="row">
                <div class="col-xs-4"><strong>{{'sales_channel' | translate | capitalize}}</strong></div>
                <div class="col-xs-4"><strong>{{'erp_store_id' | translate }}</strong></div>
                <div class="col-xs-4 text-center"><strong>{{'submit' | translate | capitalize}}</strong></div>
              </div>
              <hr>
            </div>
              <div class="col-xs-12">
                <div class="row" v-for="item, index in extensions">
                  <div class="col-xs-4">
                    <div class="form-group">
                      <input v-validate="'required|numeric'" data-vv-as="Sales Channel ID" :name="'sales_channel_id' + index" class="form-control" type="text" placeholder="Sales channel ID" v-model="item.sales_channel_id">
                      <span v-show="errors.has('sales_channel_id' + index)" class="small text-danger">{{ errors.first('sales_channel_id' + index) }}</span>
                    </div>
                  </div>
                  <div class="col-xs-4">
                    <div class="form-group">
                      <input v-validate="'required|numeric'" data-vv-as="Store ID" :name="'selling_store_id' + index" class="form-control" type="text" placeholder="Store ID" v-model="item.selling_store_id">
                      <span v-show="errors.has('selling_store_id' + index)" class="small text-danger">{{ errors.first('selling_store_id' + index) }}</span>
                    </div>
                  </div>
                  <div class="col-xs-4 text-center">
                    <button v-if='item.editable' class="btn btn-info" @click="postData(item, 'PUT', index)"><i class="fa fa-edit"></i> {{'confirm' | translate}}</button>
                    <button :disabled="errors.any()" v-else="" class="btn btn-success" @click="postData(item, 'POST', index)"><i class="fa fa-save"></i> {{'submit' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          <div class="row" v-else>
            <div class="col-xs-12">
              <div class="row">
                <div class="col-xs-2"><strong>{{'sales_channel' | translate | capitalize}} ID</strong></div>
                <div class="col-xs-2"><strong>{{'shipping_cost' | translate | capitalize}} ID</strong></div>
                <div class="col-xs-2"><strong>{{'payment_method' | translate | capitalize}} ID</strong></div>
                <div class="col-xs-3"><strong>iShop</strong></div>
                <div class="col-xs-3 text-center"><strong>{{'submit' | translate}}</strong></div>
              </div>
              <hr>
            </div>
            <div class="col-xs-12">
              <div class="row" v-for="item, index in extensions">
                <div class="col-xs-2">
                  <div class="form-group">
                    <input v-validate="'required|numeric'" data-vv-as="Sales Channel ID" :name="'sales_channel_id' + index" class="form-control" type="text" placeholder="Sales channel ID" v-model="item.sales_channel_id">
                    <span v-show="errors.has('sales_channel_id' + index)" class="small text-danger">{{ errors.first('sales_channel_id' + index) }}</span>
                  </div>
                </div>
                <div class="col-xs-2">
                  <div class="form-group">
                    <input v-validate="'required|numeric'" data-vv-as="Shipping Cost ID" :name="'shipping_cost_id' + index" class="form-control" type="text" placeholder="Shipping Cost ID" v-model="item.shipping_cost_id">
                    <span v-show="errors.has('shipping_cost_id' + index)" class="small text-danger">{{ errors.first('shipping_cost_id' + index) }}</span>
                  </div>
                </div>
                <div class="col-xs-2">
                  <div class="form-group">
                    <input v-validate="'required|numeric'" data-vv-as="Payment Cost ID" :name="'payment_id' + index" class="form-control" type="text" placeholder="Payment ID" v-model="item.payment_id">
                    <span v-show="errors.has('payment_id' + index)" class="small text-danger">{{ errors.first('payment_id' + index) }}</span>
                  </div>
                  </div>
                <div class="col-xs-3">
                  <div class="form-group">
                    <input v-validate="'required'" data-vv-as="iShop" :name="'ishop' + index" class="form-control" type="text" placeholder="iShop" v-model="item.ishop">
                    <span v-show="errors.has('ishop' + index)" class="small text-danger">{{ errors.first('ishop' + index) }}</span>
                  </div>
                </div>
                <div class="col-xs-3 text-center">
                    <button v-if='item.editable' class="btn btn-info" @click="postData(item, 'PUT', index)"><i class="fa fa-edit"></i> {{'confirm' | translate}}</button>
                    <button :disabled="errors.any()" v-else="" class="btn btn-success" @click="postData(item, 'POST', index)"><i class="fa fa-save"></i> {{'submit' | translate}}</button>
                </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    props: ['id'],
    data () {
      return {
        caller: this.$http,
        stores: {},
        alerts: [],
        extensions: {},
        params: {},
        count: 0,
        language: this.$store.getters.language,
        translate: this.$parent.translate,
        isActive: ''
      }
    },
    methods: {
      create () {
        let ext
        if (this.params.erp === 'his') {
          ext = {
            sales_channel_id: '',
            shipping_cost_id: '',
            payment_id: '',
            ishop: ''
          }
          this.extensions.push(ext)
        } else {
          ext = {
            sales_channel_id: '',
            selling_store_id: ''
          }
          this.extensions.push(ext)
        }
        this.count = this.extensions.length
      },
      customValidate (data, index) {
        if (this.params.erp === 'his') {
          return this.$validator.validate(
            `sales_channel_id${index}`, data.sales_channel_id) &&
            this.$validator.validate(`shipping_cost_id${index}`, data.shipping_cost_id) &&
            this.$validator.validate(`ishop${index}`, data.ishop) &&
            this.$validator.validate(`payment_id${index}`, data.payment_id)
        } else {
          return this.$validator.validate(
            `sales_channel_id${index}`, data.sales_channel_id) &&
            this.$validator.validate(`selling_store_id${index}`, data.selling_store_id)
        }
      },
      postData (data, method, index) {
        this.customValidate(data, index).then(result => {
          if (result) {
            let url = `accounting/companies/${this.params.company_id}/${this.params.erp}/${this.params.id}/extension`
            url += method === 'PUT' ? `/${data.id}` : ''
            this.$parent.callAPI(method, url, data)
              .then(response => {
                API.get(`accounting/companies/${this.params.company_id}/${this.params.erp}/${this.params.id}/extension`, {})
                  .then(response => {
                    this.extensions = response.body
                    for (let x in this.extensions) {
                      this.extensions[x].editable = true
                    }
                  })
                  .catch(error => {
                    this.checkError(error)
                  })
            })
          }
        })
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.params = this.$parent.$route.params
        API.get(`accounting/companies/${this.params.company_id}/${this.params.erp}/${this.params.id}/extension`, {})
          .then(response => {
            this.extensions = response.body
            this.count = this.extensions.length
            for (let x in this.extensions) {
              this.extensions[x].editable = true
            }
          })
          .catch(error => {
            this.checkError(error)
          })
      })
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/tools/ErpExtensionComponent.vue